// src/hooks/usePendingAccessRequests.js
import { useEffect, useState } from "react";
import { db } from "@/firebase/firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";

export default function usePendingAccessRequests(userProfile) {
  const [pendingRequests, setPendingRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Depend on stable primitives, NOT the userProfile object reference.
  // AuthContext re-creates userProfile on every auth tick, so depending
  // on the object caused this effect to tear down + re-mount the
  // onSnapshot listener every render, which made the sidebar flicker.
  const email = userProfile?.email || null;
  const role  = userProfile?.role || null;
  const rolesKey = Array.isArray(userProfile?.roles)
    ? userProfile.roles.join(',')
    : '';

  useEffect(() => {
    if (!email) {
      setPendingRequests([]);
      setLoading(false);
      return;
    }
    const allowed = ["coach", "manager", "team_manager", "admin"];
    const userRoles = rolesKey ? rolesKey.split(',') : [role];
    if (!userRoles.some(r => allowed.includes(r))) {
      setPendingRequests([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, "access_requests"),
      where("coachEmail", "==", email),
      where("status", "==", "pending")
    );
    const unsub = onSnapshot(q, snap => {
      setPendingRequests(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    }, err => {
      setError(err.message || "Error loading requests");
      setLoading(false);
    });
    return () => unsub();
  }, [email, role, rolesKey]);

  return { pendingRequests, loading, error };
}
